import React from 'react'
import { Card, Row, Col, Progress, Button, Typography, Space, Statistic } from 'antd'
import {
  FileTextOutlined,
  BarChartOutlined,
  CalendarOutlined,
  TeamOutlined,
  BookOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons'
import useReportSummary from '../Hooks/Reports/useReportSummary'

import { useNavigate } from 'react-router-dom'

const { Title, Text } = Typography

const cardStyle = {
  flex: '0 0 20%', // 100% / 5 cards
};

const cardBodyStyle = {
  minHeight: 120,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};




export default function ReportsPage() {
  const { data, loading } = useReportSummary();
  const navigate = useNavigate()

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: 24 }}>
      {/* Header */}
      <div style={{ marginBottom: 32 }}>
        <Title level={2}>Reports & Analytics</Title>
        <Text type="secondary">
          Comprehensive overview of your organizations performance
        </Text>
      </div>

      {/* Stats Cards */}
      <Row gutter={[16, 16]} wrap={false} style={{ marginBottom: 32 }}>
        <Col style={cardStyle}>
          <Card className="card-professional"
            style={cardBodyStyle}
          >
            <Statistic
              title="Total Learners"
              value={data.totalLearners}
              prefix={<TeamOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {data.learnersJoinedThisMonth} + this month
            </Text>
          </Card>
        </Col>

        <Col style={cardStyle}>
          <Card className="card-professional" style={cardBodyStyle}>
            <Statistic
              title="Total Organizations"
              value={data.totalOrganizations}
              prefix={<BookOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
            {data.pendingOrganizationRequests > 0 && <Text type="secondary" style={{ fontSize: '12px', color: '#ff4d4f' }}>
              Pending Organizations {data.pendingOrganizationRequests}
            </Text>}
          </Card>
        </Col>

        <Col style={cardStyle}>
          <Card className="card-professional" style={cardBodyStyle}>
            <Statistic
              title="Total Courses"
              value={data.totalCourses}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#faad14' }}
            />

          </Card>
        </Col>

        <Col style={cardStyle}>
          <Card style={cardBodyStyle} className='card-professional'>
            <Space size={16}>
              <totalCertificatesIssued style={{ fontSize: 26, color: '#722ed1' }} />
              <div>
                <Text type="secondary">Total Issued Certificates</Text>
                <Title level={3} style={{ margin: 0 }}>
                  {data.totalCertificatesIssued}
                </Title>

              </div>
            </Space>
          </Card>
        </Col>
        <Col style={cardStyle}>
          <Card className="card-professional" style={cardBodyStyle}>
            <Statistic
              title="Total Enrolled"
              value={data.totalEnrollments}
              suffix=""
              prefix={<BarChartOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {data.enrollmentsThisMonth} + This month Enrolled
            </Text>
          </Card>
        </Col>
      </Row>

      {/* Progress Section */}
      <Row gutter={[24, 24]} style={{ marginBottom: 32 }}>
        <Col xs={24} lg={12}>
          <Card title="Enrollment Progress">
            <Space
              style={{ width: '100%', justifyContent: 'space-between' }}
            >
              <Text>Overall Enrollment Progress</Text>
              <Text>{data.enrollmentCompletionPercentage}%</Text>
            </Space>

            <Progress
              percent={data.enrollmentCompletionPercentage}
              showInfo={false}
              style={{ marginTop: 8 }}
            />

            <Text type="secondary">
              Average Enrollment progress across all active projects
            </Text>
          </Card>
        </Col>

        <Col xs={24} lg={12}>

        </Col>
      </Row>
      {/* Available Reports */}
      <Card title="Available Reports">
        <Row gutter={[24, 24]}>
          {[
  {
    title: 'Learner Master Registry',
    desc: 'Profile-wise performance and registry details with completion status and geographic filters.',
    btn: 'View Master Report →',
    path: '/proAdmin-dashboard/learner-report',
  },
  {
    title: 'Engagement Analysis',
    desc: 'Deep dive into active/inactive learner trends and enrollment frequency over time.',
    btn: 'Analyze Activity →',
    path: '/proAdmin-dashboard/learner-activities-report'
  },
  {
    title: 'Organization Audit',
    desc: 'Comprehensive overview of tenant organizations, status monitoring, and specialty tracking.',
    btn: 'View Org Report →',
    path: '/proAdmin-dashboard/organization-report',
  },
  {
    title: 'Course Analytics',
    desc: 'Metric-based report on course pricing, durations, and publication life-cycles.',
    btn: 'Generate Metrics →',
    path: '/proAdmin-dashboard/course-report',
  },
  {
    title: 'Enrollment Tracking',
    desc: 'Detailed financial overview and volume tracking of student enrollments per course.',
    btn: 'View Enrollments →',
    path: '/proAdmin-dashboard/course-enrollments-report',
  },
  {
    title: 'Financial Ledgers',
    desc: 'Complete transaction history and financial record auditing across all payment sources.',
    btn: 'Open Ledgers →',
    path: '/proAdmin-dashboard/ledgers-report',
  }
].map((item, index) => (
            <Col xs={24} md={12} lg={8} key={index}>
              <Card
                bordered
                hoverable={Boolean(item.path)}
                onClick={() => {
                  if (item.path) navigate(item.path)
                }}
              >
                <Title level={5}>{item.title}</Title>
                <Text type="secondary">{item.desc}</Text>
                <div style={{ marginTop: 12 }}>
                  <Button type="link" style={{ padding: 0 }}>
                    {item.btn}
                  </Button>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>



    </div>
  )
}
